import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from "@angular/core";

import { ApiConfiguration } from "../api/api-configuration";
import { environment } from "../../../environments/environment";
import { ApiModule } from "../api/api.module";

export function provideApiWithInterceptor(): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: ApiConfiguration,
            useFactory: () => {
                const url = environment.apiUrl;
                const apiConfiguration = new ApiConfiguration();
                apiConfiguration.rootUrl = url;
                return apiConfiguration;
            }
        },
        importProvidersFrom(ApiModule.forRoot({
            rootUrl: environment.apiUrl
        }))
    ]);
}